export const zikrPresets = [
  { key: 'subhanallah', label: 'SubhanAllah', defaultTarget: 33 },
  { key: 'alhamdulillah', label: 'Alhamdulillah', defaultTarget: 33 },
  { key: 'allahuakbar', label: 'Allahu Akbar', defaultTarget: 34 },
  { key: 'astaghfirullah', label: 'Astaghfirullah', defaultTarget: 100 },
  { key: 'lailahaillallah', label: 'La ilaha illallah', defaultTarget: 100 }
]
